<template>
  <Page :pagination="pagination">
    <template #content>
      <p class="page-title">Badges de personnalité</p>
      <div class="container" data-convert="badges">
        <div class="badges-wrapper">
          <!-- Display the first 6 badges otherwise it goes out of the page -->
          <div v-for="badge, key in badgesAcquired" :key="key" class="badge">
            <img :src="badge.img" :alt="badge.title" />
            <div class="text">
              <span class="title">{{ badge.title }}</span>
              <span class="description">{{ badge.description.organisation }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Page>
</template>


<style lang="scss" scoped>
.page {
  .container {
    display: flex;
    flex-direction: column;
    gap: 32px;

    height: 100%;

    .badges-wrapper {
      display: flex;
      flex-direction: column;

      height: 90%;

      .badge {
        display: flex;
        gap: 24px;

        overflow-x: auto;
        overflow-y: hidden;

        img {
          max-height: 107px;
        }

        .text {
          text-align: initial;
          display: flex;
          flex-direction: column;
          gap: 8px;

          .title {
            font-size: 14px;
            font-weight: 700;
          }

          .description {
            font-size: 10px;
            text-align: justify;
          }
        }
      }
    }
  }

  .content-title {
    font-weight: 700;
    font-size: 22px;
    margin-bottom: 22px;
    line-height: 28px;
    margin-right: auto;
    text-transform: uppercase;
  }
}
</style>

<script setup>
import Page from "../Page.vue";
import { computed, onMounted } from "vue";
import badges from "@/assets/badges.json";

const props = defineProps({
  pagination: {
    type: String,
    required: true,
  },
  candidate: {
    type: Object,
    required: true,
  },
  modules: {
    type: Array,
    required: true,
  },
});

const badgesAcquired = computed(() => {
  return Object.entries(props.candidate.results)
    .filter(([skill, value]) => skill.includes("_badge") && value === 1)
    .map(([skill, value]) => badges[skill.replace("_badge", "")]);
});

const badgesAmount = computed(() => badgesAcquired.value.length);

/**
 * Function that clamps a value between a minimum and maximum value depending on a percentage between 0 and 1.
 * If percent is 0, it returns the minimum value.
 * If percent is 1, it returns the maximum value.
 * If percent is between 0 and 1, it returns a value between the minimum and maximum value.
 */
function clampFontSize(min, max, percent) {
  return min + (max - min) * percent;
}

/**
 * Function that maps a value between a minimum and maximum value to a percentage between 0 and 1.
 * If x is equal to min, it returns 0.
 * If x is equal to max, it returns 1.
 * If x is between min and max, it returns a value between 0 and 1.
 */
function mapNumber(min, max, x) {
  return (x - min) / (max - min);
}

onMounted(() => {
  const badgeTitles = document.querySelectorAll(".report .badge .title");
  badgeTitles.forEach((badge) => {
    badge.style.fontSize = clampFontSize(16, 22, 1 - mapNumber(3, 8, badgesAmount.value)) + "px";
  });
  const badgeDescriptions = document.querySelectorAll(".report .badge .description");
  badgeDescriptions.forEach((badge) => {
    badge.style.fontSize = clampFontSize(12, 18, 1 - mapNumber(3, 8, badgesAmount.value)) + "px";
  });

  const wrapper = document.querySelector(".report .badges-wrapper");
  wrapper.style.gap = clampFontSize(10, 40, 1 - mapNumber(3, 8, badgesAmount.value)) + "px";
});
</script>